import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: GreenTurtwig
 * id 52228864-9BDD-4D12-82EC-AF730D68E47B
 * name television-stop
 * version: 3.9.97
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/television-stop.svg
 * tags
 * - Device / Tech 
 */
export const TelevisionStopIcon = createSvgIcon(<><path d="M3 3H21C22.1 3 23 3.89 23 5V17C23 18.1 22.1 19 21 19H16V21H8V19H3C1.9 19 1 18.1 1 17V5C1 3.89 1.89 3 3 3M3 5V17H21V5H3M9 8H15V14H9V8Z" /></>, 'TelevisionStopIcon');
export default TelevisionStopIcon